import { DateTimeInput, Field, NumericInput, TextInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetBalanceFieldSet, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import InitialDryingDryMassReadings from './InitialDryingDryMassReadingsSection';

let InitialDryingSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <NamePrefixModifier appendNamePrefix="MeasuredConstantDryMass">
        <ListFieldSection>
          <WorksheetBalanceFieldSet name="Equipment.Balance" />
          <Field input={<TextInput />} name="DryingTray.ContainerLabel" maxLength={20} />
          <Field input={<NumericInput />} name="DryingTray.ContainerMass" />
          <Field input={<NumericInput />} name="DryingTray.WetSoilAndContainerMass" />
          <Field input={<TextOutput />} name="DryingTray.WetSoilMass" />
          <Field input={<WorksheetEquipmentDropdown />} name="Equipment.Oven" equipmentType="oven" />
          <Field input={<NumericInput />} name="Equipment.DryingTemperature" />
          <Field input={<DateTimeInput />} name="DryingTray.DateTimePlacedInOvenLocal" />
          <WorksheetBalanceFieldSet name="Equipment.DryMassBalance" />
        </ListFieldSection>
        <InitialDryingDryMassReadings />
      </NamePrefixModifier>
      <ListFieldSection>
        <Field input={<TextOutput />} name="TestPortionDryMass" />
        <Field input={<TextOutput />} name="MoistureVolatileContent" />
      </ListFieldSection>
    </>
  );
};

const InitialDryingSection = withInjectedProps(InitialDryingSectionBase);

export { InitialDryingSection };
export default InitialDryingSection;
